module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_comment_modal),
      expression: "show_comment_modal"
    }],
    staticClass: "resizable",
    attrs: {
      "id": "global-comment-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "comment-modal-header"
  }, [_c('h5', {
    staticClass: "comment-modal-title overflow-ellipsis"
  }, [_vm._v("Comentários - " + _vm._s(_vm.contacts_name))]), _c('button', {
    staticClass: "close-comment-modal",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/fechar.svg")
    }
  })])]), _vm._m(0), _c('div', {
    staticClass: "comment-modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-gray",
    attrs: {
      "id": "cancel",
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancelar")]), (_vm.edit_comment) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "id": "destroy",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeComment()
      }
    }
  }, [_vm._v("Excluir")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "save",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveComment()
      }
    }
  }, [_vm._v("Salvar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-modal-body"
  }, [_c('textarea', {
    attrs: {
      "id": "comment-modal",
      "name": "comment"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-85cc8c78!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/modals/comment.vue
// module id = 1181
// module chunks = 1